import React from 'react';

import {
  Search,
} from 'lucide-react';

import type {
  StoreListItem,
} from '../../store/types/store.types';

import type {
  StatusFilter,
  StoreFilter,
} from '../hooks/useAdminMembers';

type MemberFilterBarProps = {
  stores: StoreListItem[];

  searchTerm: string;

  statusFilter:
    StatusFilter;

  storeFilter:
    StoreFilter;

  onSearchChange:
    (value: string) => void;

  onStatusChange:
    (
      value:
        StatusFilter,
    ) => void;

  onStoreChange:
    (
      value:
        StoreFilter,
    ) => void;
};

const MemberFilterBar:
  React.FC<
    MemberFilterBarProps
  > = ({
    stores,
    searchTerm,
    statusFilter,
    storeFilter,
    onSearchChange,
    onStatusChange,
    onStoreChange,
  }) => {
  return (
    <section className="mb-5 grid shrink-0 grid-cols-1 gap-3 sm:mb-6 sm:grid-cols-2 lg:grid-cols-[minmax(280px,1fr)_180px_180px]">
      <div className="relative sm:col-span-2 lg:col-span-1">
        <Search
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          size={20}
        />

        <input
          type="search"
          placeholder="이름, 닉네임, 전화번호, 아이디 검색"
          value={
            searchTerm
          }
          onChange={(
            event,
          ) =>
            onSearchChange(
              event.target
                .value,
            )
          }
          className="w-full rounded-lg border border-gray-300 bg-white py-3 pl-10 pr-4 text-sm outline-none transition focus:border-main focus:ring-2 focus:ring-main/10 sm:text-base"
        />
      </div>

      <select
        value={
          statusFilter
        }
        onChange={(
          event,
        ) =>
          onStatusChange(
            event.target
              .value as StatusFilter,
          )
        }
        className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm outline-none transition focus:border-main focus:ring-2 focus:ring-main/10 sm:text-base"
      >
        <option value="all">
          전체 상태
        </option>

        <option value="ACTIVE">
          활성
        </option>

        <option value="PENDING">
          대기
        </option>

        <option value="INACTIVE">
          비활성
        </option>
      </select>

      <select
        value={
          storeFilter
        }
        onChange={(
          event,
        ) => {
          const value =
            event.target
              .value;

          onStoreChange(
            value === 'all'
              ? 'all'
              : Number(
                  value,
                ),
          );
        }}
        className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm outline-none transition focus:border-main focus:ring-2 focus:ring-main/10 sm:text-base"
      >
        <option value="all">
          전체 지점
        </option>

        {stores.map(
          (store) => (
            <option
              key={
                store.storeId
              }
              value={
                store.storeId
              }
            >
              {
                store.storeName
              }
            </option>
          ),
        )}
      </select>
    </section>
  );
};

export default MemberFilterBar;